export enum DashboardColumns {
  STATUS = 'STATUS',
  DNI_CIF = 'DNI_CIF',
  AG_CODE = 'AG_CODE',
  CUSTOMER = 'CUSTOMER',
  DATE = 'DATE',
  AMOUNT = 'AMOUNT',
  EMAIL = 'EMAIL',
  OFFER = 'OFFER',
  PROPOSAL_TERM = 'PROPOSAL_TERM',
  CART_ID = 'CART_ID',
  PRODUCT = 'PRODUCT',
  APPLICATION = 'APPLICATION',
  PRODUCTS_NUM = 'PRODUCTS_NUM',
  PROCESS_TYPE = 'PROCESS_TYPE',
}
